/** Codes the same chain goes by across integrations (BSC in OTC, BNB in the card issuer's API). */
const NETWORK_ALIASES: Record<string, string> = {
  BNB: "BSC",
  ETH: "ETHEREUM",
  MATIC: "POLYGON",
  TRX: "TRON",
};

/** One code per chain, whatever the integration called it, upper-cased. */
export function canonicalNetworkCode(network: string): string {
  const code = network.toUpperCase();
  return NETWORK_ALIASES[code] ?? code;
}

/** Each chain's colour: the disc of its mark in `ColocaNetworkIcon`. For decoration that should read as it. */
const NETWORK_BRAND_COLORS: Record<string, string> = {
  BSC: "#F3BA2F",
  POLYGON: "#6F41D8",
  ETHEREUM: "#627EEA",
  TRON: "#EF0027",
};

/** A chain's brand colour by its code, aliases included; null for a chain without a mark. */
export function networkBrandColor(network: string): string | null {
  return NETWORK_BRAND_COLORS[canonicalNetworkCode(network)] ?? null;
}
